import { render, staticRenderFns } from "./bnvinteger.vue?vue&type=template&id=1afcb015&"
import script from "./bnvinteger.vue?vue&type=script&lang=js&"
export * from "./bnvinteger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports